export default (function (_ref) {
  var request = _ref.request;
  return {
    deviceWarnAdd: function deviceWarnAdd(data) {
      return request({
        url: '/iot/deviceWarn',
        method: 'post',
        data: data
      });
    },
    deviceWarnModify: function deviceWarnModify(data) {
      return request({
        url: "/iot/deviceWarn/".concat(data.id),
        method: 'put',
        data: data
      });
    },
    deviceWarnDel: function deviceWarnDel(id) {
      return request({
        url: "/iot/deviceWarn/".concat(id),
        method: 'delete'
      });
    },
    deviceWarnQuery: function deviceWarnQuery(data) {
      return request({
        url: '/iot/deviceWarn/query',
        method: 'get',
        params: data
      });
    },
    deviceWarnDetail: function deviceWarnDetail(id) {
      return request({
        url: "/iot/deviceWarn/".concat(id),
        method: 'get'
      });
    }
  };
});